export default "__VITE_ASSET__BZq3Gbym__"